module.exports = __webpack_public_path__ + "static/img/rank_221.e8dc687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_221.png
// module id = FOzB
// module chunks = 1